import React, { useRef } from 'react';
import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogContent,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogOverlay,
    Button,
    Text,
} from '@chakra-ui/react';

function ConfirmDialog({
    isOpen,
    onClose,
    onConfirm,
    title,
    description,
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
    isLoading = false,
    confirmColorScheme = 'red',
    confirmVariant = 'solid',
}) {
    const cancelRef = useRef(null);

    return (
        <AlertDialog
            isOpen={isOpen}
            leastDestructiveRef={cancelRef}
            onClose={isLoading ? () => {} : onClose}
            isCentered
            closeOnEsc={!isLoading}
            closeOnOverlayClick={!isLoading}
        >
            <AlertDialogOverlay>
                <AlertDialogContent>
                    <AlertDialogHeader fontSize="lg" fontWeight="bold">
                        {title}
                    </AlertDialogHeader>

                    <AlertDialogBody>
                        {typeof description === 'string' ? (
                            <Text whiteSpace="pre-line">{description}</Text>
                        ) : (
                            description
                        )}
                    </AlertDialogBody>

                    <AlertDialogFooter>
                        <Button ref={cancelRef} onClick={onClose} isDisabled={isLoading}>
                            {cancelLabel}
                        </Button>
                        <Button
                            colorScheme={confirmColorScheme}
                            variant={confirmVariant}
                            onClick={onConfirm}
                            ml={3}
                            isLoading={isLoading}
                        >
                            {confirmLabel}
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    );
}

export default ConfirmDialog;
